<template>
  <v-btn
    color="secondary"
    text
    small
    @click="imprimirBoleto()"
    title="Imprimir Boleto"
    rounded
    :icon="isMobile()"
  >
    <v-icon :left="!isMobile()">mdi-barcode</v-icon>
    <span v-if="!isMobile()">Boleto</span></v-btn
  >
</template>

<script>
import { getToken } from "@/global";

export default {
  props: {
    nf: Object,
  },
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    imprimirBoleto() {
      window.open(
        `${
          process.env.VUE_APP_BASE_URL
        }/nutricao-animal/downloads/download-boleto?token=${getToken()}&nf=${
          this.nf.id
        }&p=${this.nf.pessoa}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>